import { ExploreBlockSummary } from '@addmile/backend-client';

export const sortBlocksByPosition = (blocks: ExploreBlockSummary[]) => {
  return [...blocks].sort((a, b) => {
    const posA = a.position ?? 0;
    const posB = b.position ?? 0;
    if (posA !== posB) return posA - posB;
    return (a.createdAt || '').localeCompare(b.createdAt || '');
  });
};
